import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column ga-8" },
    _vm._l(_vm.serviceGroups, function (serviceGroup) {
      return _c(
        "div",
        {
          key: serviceGroup.name,
          staticClass: "d-flex flex-column ga-6",
          attrs: { "data-qa": "service_group" },
        },
        [
          _c(
            "h2",
            {
              staticClass: "text--text text-h5",
              attrs: { "data-qa": "service_group_name" },
            },
            [_vm._v("\n      " + _vm._s(serviceGroup.name) + "\n    ")]
          ),
          _vm._v(" "),
          _c(VDivider),
          _vm._v(" "),
          _c(
            VExpansionPanels,
            _vm._l(serviceGroup.serviceClasses, function (serviceClass) {
              return _c(
                VExpansionPanel,
                {
                  key: serviceClass.name,
                  attrs: { "data-qa": "service_class" },
                },
                [
                  _c(
                    VExpansionPanelHeader,
                    {
                      staticClass: "text-left",
                      attrs: { "expand-icon": "ui-icon-arrow-down" },
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass: "text-h6 text--text",
                          attrs: { "data-qa": "service_class_name" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(serviceClass.name) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(VExpansionPanelContent, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "d-inline-block text-h6 primary--text link-decoration-underline mb-4",
                        attrs: {
                          "data-qa": "service_class_name",
                          href: serviceClass.href,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(serviceClass.name) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "d-flex flex-column ga-6 pl-2",
                        attrs: { "data-qa": "service_categories" },
                      },
                      _vm._l(
                        serviceClass.serviceCategories,
                        function ({ name, href, serviceTypes }) {
                          return _c(
                            "div",
                            {
                              key: name,
                              staticClass: "d-flex flex-column w-100",
                              attrs: { "data-qa": "service_category" },
                            },
                            [
                              name
                                ? _c(
                                    "h3",
                                    { staticClass: "text-subtitle-1 mb-4" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text--text link-decoration-underline",
                                          attrs: {
                                            href: href,
                                            "data-qa": "service_category_name",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(name) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(_setup.ServiceTypes, {
                                staticClass: "pl-2",
                                attrs: { "service-types": serviceTypes },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }